export default "__VITE_ASSET__CILG5CHA__"